import type {MRT_PaginationState, MRT_SortingState} from 'material-react-table';
import type {StatementSearchSchema} from '@/components/StatementSearchForm/StatementSearchForm.tsx';
import {apiUrl} from '@/utils/api';
import type {GetSearchStatementResults} from "@/types/GetSearchStatementResults.ts";

export const getStatementsSearch = async (
    searchCriteria : StatementSearchSchema,
    pagination : MRT_PaginationState,
    sorting : MRT_SortingState,
) : Promise<GetSearchStatementResults> => {
    const response = await fetch(
        apiUrl('/statements/search').toString(),
        {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...searchCriteria,
                ...pagination,
                sorting: sorting,
            }),
        }
    );

    if (!response.ok) {
        throw new Error('Unable to fetch statements.');
    }

    return await response.json() as GetSearchStatementResults;
};
